const viewOrgPageTabSlugs = ['JOB', 'INTERNSHIP', 'VOLOP', 'EVENT'] as const;

export type ViewOrgPageTabSlug = (typeof viewOrgPageTabSlugs)[number];

export function isViewOrgPageListingTabSlug(
  value: string | undefined,
): value is ViewOrgPageTabSlug {
  return Boolean(value && viewOrgPageTabSlugs.includes(value));
}
